import React from 'react';
import classNames from 'classnames';

import OneValue from 'components/OneValue';
import displayHashrateValue from 'common/displayHashrateValue';
import roundToGivenDecimals from 'common/roundToGivenDecimals';
import IDashboardData from 'pages/Dashboard/IDashboardData';

import './PoolStatisticsSummary.scss';

// Compact a large magnitude into a value + SI-ish suffix (difficulty is ~1e14
// on mainnet, far smaller on testnet, so pick the suffix dynamically).
const compact = (n: number): { value: number; unit: string } => {
  const units: [string, number][] = [['T', 1e12], ['G', 1e9], ['M', 1e6], ['K', 1e3]];

  for (const [suffix, divisor] of units) {
    if (n >= divisor) return { value: roundToGivenDecimals(n / divisor, 2), unit: suffix };
  }
  return { value: roundToGivenDecimals(n, 2), unit: '' };
};

const PoolStatisticsSummary = ({ data, isLoading }: { data: IDashboardData, isLoading: boolean }) => {
  const { unit, value } = displayHashrateValue(parseFloat(data?.pool_effective_hashrate ?? '0'));
  const difficulty = data?.pool_network_difficulty;
  const miners = data?.pool_connected_miners;
  const diff = difficulty ? compact(parseFloat(difficulty)) : null;

  const boxClass = classNames({ box: true, isLoading });

  return (
    <div className='pool-statistics-summary'>
      <h3>Pool Statistics</h3>
      <div className='pool-statistics-grid'>
        <OneValue
          className={boxClass}
          title='Pool Effective HR (30m avg)'
          unit={`${unit}h/s`}
          value={value}
        />
        {diff && (
          <OneValue
            className={boxClass}
            title='Network Difficulty'
            unit={diff.unit}
            value={diff.value}
          />
        )}
        {typeof miners === 'number' && (
          <OneValue
            className={boxClass}
            title='Connected Miners'
            unit=''
            value={miners}
          />
        )}
      </div>
    </div>
  );
};

export default PoolStatisticsSummary;
